"use strict";

require("mq-respond/mqRes.min");

const mqRespondInit = () => {
    const mqRespond = new window.mqRes([
        {
            label: "lgDown",
            from: 0,
            to: 1199
        },
        {
            label: "xsOnly",
            from: 0,
            to: 574
        },
        {
            label: "xsUp",
            from: 575
        },
        {
            label: "smOnly",
            from: 575,
            to: 767
        },
        {
            label: "smUp",
            from: 768
        },
        {
            label: "mdOnly",
            from: 768,
            to: 991
        },
        {
            label: "mdUp",
            from: 992
        },
        {
            label: "lgOnly",
            from: 992,
            to: 1199
        },
        {
            label: "lgUp",
            from: 1200
        }
    ]);

    return mqRespond;
};

module.exports = {
    mqRespondInit: mqRespondInit
};
